import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import muiThemeable from 'material-ui/styles/muiThemeable';



const NavItem = (props) => (
  <div style={{display: 'inline-block'}}>
    <NavLink
      exact={props.exact}
      to={props.to}
      activeStyle={{backgroundColor: props.darker ? props.theme.palette.primary3Color : props.theme.palette.primary2Color}}
      style={{display: 'inline-block', lineHeight: props.height, padding: '0 16px', textDecoration: 'none', transition: 'all .2s ease-in-out', color: 'white', ':hover': {
        backgroundColor: props.theme.palette.primary2Color
      }}}>
      {props.children}
    </NavLink>
  </div>
);

class Navigation extends Component {
  render() {
    return (
      <div>
        {this.props.items.map((item, index) =>
          <NavItem key={index} darker={!!this.props.darker} exact={item.exact} theme={this.props.muiTheme} to={item.to} height={this.props.height || '48px'}>{item.text}</NavItem>
        )}
      </div>
    );
  }
}

export default muiThemeable()(Navigation);



// WEBPACK FOOTER //
// ./src/components/Header/Navigation.js